/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Dimension } from '../UNSAFE_visTypes/common';

export const inSpace = (x: number, y: number, dimensions: Dimension) => {
  const minX = dimensions.x;
  const minY = dimensions.y;
  const maxX = dimensions.x + dimensions.width;
  const maxY = dimensions.y + dimensions.height;
  if (x < minX || x > maxX || y < minY || y > maxY) {
    return false;
  }
  return true;
};

/**
 * Returns the shape ramp used for markers for line/area charts.
 * @returns {readonly string[]} The shape ramp.
 */
export function getShapeRamp() {
  return ['square', 'circle', 'diamond', 'plus', 'triangleDown', 'triangleUp'] as const;
}
